import { render, staticRenderFns } from "./PsText.vue?vue&type=template&id=18be1e7b&scoped=true&"
import script from "./PsText.vue?vue&type=script&lang=js&"
export * from "./PsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be1e7b",
  null
  
)

export default component.exports